import React from 'react'
import { projectDetails } from './Data'
import { Link } from 'react-router-dom'
import img from './Images/ReadyPlayer.png'

const Project = () => {
  return (
    <>
        <div className="project">
            <div className="title">VR Projects</div>
            <div className="grid">
                {projectDetails.slice(0, 8).map(project => (
                   <Link to={`/projectDetails/${project.id}`} key={project.id} className='projectlink'>
                        {project.projectName}
                    </Link>
                ))}
            </div>
            <img src={img} alt="" />
            <div className="title second">3D Projects</div>
            <div className="grid">
                {projectDetails.slice(8, 10).map(project => (
                   <Link to={`/projectDetails/${project.id}`} key={project.id} className='projectlink'>
                        {project.projectName}
                    </Link>
                ))}
            </div>
            <div className="title third">2D Projects</div>
            <div className="grid">
                {projectDetails.slice(10, 11).map(project => (
                   <Link to={`/projectDetails/${project.id}`} key={project.id} className='projectlink'>
                        {project.projectName}
                    </Link>
                ))}
            </div>
        </div>
    </>
  )
}

export default Project